import get from 'transmute/get';
import { TEXT, FILE_ID } from '../constants/messageHeaderAttachmentKeyPaths';
export const getText = attachment => {
  return get(TEXT, attachment);
};
export const getFileId = attachment => {
  return get(FILE_ID, attachment);
};